import { INSURER_NAMES } from "@/static/constants";
import { isInsurer } from ".";
import { Quote } from "@/stores/risk/types/types";

export const siteLinks = {
    eligibilityCriteria: "https://www.anpostinsurance.ie/home-quote-eligibility-criteria",
    termsOfBusiness: "https://www.anpostinsurance.ie/Webdocs/Documents/Live/TermsOfBusiness-AnPostInsurance.pdf",
    faqs: "https://www.anpostinsurance.ie/help-centre",
    privacyPolicy: "https://www.anpostinsurance.ie/data-protection",
    cookiesPolicy: "https://www.anpostinsurance.ie/cookies"
};

const supplierInformationDocuments: Record<string, string> = {
    [INSURER_NAMES.Allianz]:
        "https://www.anpostinsurance.ie/Webdocs/Documents/Live/ImportantSupplierInformation-AnPostInsurance-Home-Allianz.pdf",
    [INSURER_NAMES.Aviva]:
        "https://www.anpostinsurance.ie/Webdocs/Documents/Live/ImportantSupplierInformation-AnPostInsurance-Home-Aviva.pdf"
};

export function getSupplierInformationDocumentLink(quote: Quote) {
    if (isInsurer(quote, INSURER_NAMES.Allianz)) {
        return supplierInformationDocuments[INSURER_NAMES.Allianz];
    } else {
        return supplierInformationDocuments[INSURER_NAMES.Aviva];
    }
}
